import { AfterViewInit, Component, forwardRef, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NzInputNumberComponent } from 'ng-zorro-antd/input-number';
import { AbstractControlComponent } from "../../../classes/abstract-control.component";

@Component({
  selector: 'vss-ui-input-number',
  templateUrl: './cs-input-number.component.html',
  styleUrls: ['./cs-input-number.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CsInputNumberComponent),
      multi: true
    }
  ],
  encapsulation: ViewEncapsulation.None
})
export class CsInputNumberComponent extends AbstractControlComponent<number> implements AfterViewInit {

  @Input() maxLength: number = 18;
  @Input() csMin: number = 0;
  @Input() csMax: number = Infinity;
  @Input() csStep: number = 1;
  @Input() csPrecision!: number;
  @Input() hiddenStep = true;
  @Input() csParser = (value: string) => value.trim().replace(/。/g, '.').replace(/[^\w\.-]+/g, '');
  @Input() csFormatter: (value: number) => any = value => {
    if(isNaN(value) || value == null) return null
    const values = value?.toString()?.split('.')
    return `${values[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}${values?.length > 1 ? '.' + values[1] : ''}`
  }
  @Input() csPrecisionMode: 'cut' | 'toFixed' | ((value: number | string, precision?: number) => number) = 'toFixed';
  @Input() csInputMode: 'numeric' | 'decimal' = 'numeric'


  @ViewChild(NzInputNumberComponent) child!: NzInputNumberComponent;
  constructor() {
    super();
  }

  ngAfterViewInit(): void {
    this.child?.inputElement.nativeElement.addEventListener('keydown', (e) => {
      if(this.csInputMode === 'numeric'){
        if(e.ctrlKey) return;
        if (!/([0-9]|ArrowUp|ArrowDown|Backspace)/g.test(e.key)) {
          e.preventDefault();
          return;
        }
        setTimeout(() => {
          const value = this.child?.inputElement.nativeElement.value;
          const actualValue = this.csParser(value);
          if(!isNaN(+actualValue)){
            this.child.updateDisplayValue(Number(actualValue));
          }
        }, 0);
      }
    });
    this.child?.inputElement.nativeElement.addEventListener('keypress', (e) => this.onKeypress(e));
  }

  onBlur(): void {
    if ((this.csMin || this.csMin === 0) && !this.controlValue) {
      this.controlValue = this.csMin;
    }
  }

  onKeypress(e: any) {
    if(e.target?.value?.length >= this.maxLength) {
      e.preventDefault()
    }
  }
}
